import Vue from "modules/vue_twemoji";
import VueI18n from "vue-i18n";
import QuestOnboarding from "components/quest-onboarding";
import { store } from "store";

Vue.use(VueI18n);

const $questOnboardingContainer = document.querySelector(".js-quest-onboarding");

if($questOnboardingContainer) {
  const questSlug = $questOnboardingContainer.dataset.questSlug;

  new Vue({
    i18n: new VueI18n({
      locale: "en"
    }),
    store,
    el: $questOnboardingContainer,
    render: h => h(QuestOnboarding, {
      props: {
        questSlug: questSlug
      }
    })
  });
}
